export enum FormControlErrorTypeEnum {
	lessThan = 'lessThan',
	greaterThan = 'greaterThan'
}
